const SELECTOR = '.js-newsletter';

export function init() {
    const newsletterElements = document.querySelectorAll(SELECTOR);

    if (newsletterElements === null) {
        return false;
    }

    newsletterElements.forEach(element => {
        element.addEventListener('submit', event => {
            event.preventDefault();

            const formData = new FormData(element);
            const email = formData.get('email');
            const baseUrl = element.dataset.ctaUrl;

            if (!baseUrl) {
                return window.location.href = `https://chambermusicsociety.prospect2.com/f/1?email=${encodeURIComponent(email)}`;
            }

            // If the URL already contains a query string, append email; otherwise start a new query string
            const separator = baseUrl.includes('?') ? '&' : '?';
            return window.location.href = `${baseUrl}${separator}email=${encodeURIComponent(email)}`;
        });
    });
}
